import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Paper } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    minWidth: 100,
    justifyContent: "center",
  },
  bullet: {
    display: "inline-block",
  },
  title: {
    fontSize: 14,
  },
  bodyText: {
    fontSize: 20,
  },
});

export interface SpeechExampleProps {
  text: string;
  author: string;
  title: string;
  freeAudio?: string;
  premiumAudio?: string;
}
const SpeechExample: FC<SpeechExampleProps> = ({ text, author, title }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={4}>
      <CardContent>
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {author}
        </Typography>

        <Typography className={classes.bodyText} component="p">
          {text}
        </Typography>
      </CardContent>
    </Paper>
  );
};
export default SpeechExample;
